































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import AppStore from '@/store/App';
import MasterStore from '@/store/MasterStore';

@Component({
    metaInfo: {
        changed: function (meta) {
            if(meta.title)
                AppStore.SET_TITLE(meta.title);
            if((meta as any).backTo)
                AppStore.SET_BACK_LINK((meta as any).backTo)
            else
                AppStore.SET_BACK_LINK("")
        }
    }
})
export default class CoreToolbar extends Vue {
  notifications = [
    'Mike, John responded to your email',
    'You have 5 new tasks',
    'You\'re now a friend with Andrew',
    'Another Notification',
    'Another One'
  ];
  responsive = false;
  timeoutId?: any;

  get title() {
      return AppStore.title;
  }

  get backTo() {
      return AppStore.backLink;
  }
  
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  }

  setDrawer( val: boolean ) { AppStore.SET_DRAWER(val); }
  toggleDrawer() { AppStore.TOGGLE_DRAWER(); }

  onClick() {
    this.setDrawer(!this.$store.state.app.drawer);
  }
  onResponsiveInverted() {
    this.responsive = window.innerWidth < 991;
  }

  async logout() {
    if(await AppStore.showConfirm({ message: "ログアウトしてもよろしいですか？", caption: "" })) {
      if(await MasterStore.execDeauthentication()) {
        // リダイレクト
        this.$router.push('/login');
      }
      else {
        AppStore.showError("サーバー上でエラーが発生しました。");
      }
    }
  }

  updateSearch(str: string) {
      if(this.timeoutId) clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
          this.timeoutId = 0;
          AppStore.UPDATE_SEARCH_TEXT(str);
      }, 100);
  }
}
